import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getProfileThunk = createAsyncThunk(
  'profile/getProfile',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      return {};
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProfileThunk = createAsyncThunk(
  'profile/updateProfile',
  async (profileData, { rejectWithValue }) => {
    try {
      return profileData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const uploadProfilePictureThunk = createAsyncThunk(
  'profile/uploadProfilePicture',
  async ({ file }, { rejectWithValue }) => {
    try {
      return { profilePicURL: '' };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  firstName: null,
  lastName: null,
  email: null,
  mobile: null,
  profilePicURL: null,
  city: null,
  state: null,
  timeZone: null,
  loading: false,
  error: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfileThunk.fulfilled, (state, action) => {
        state.loading = false;
        Object.assign(state, action.payload);
      })
      .addCase(getProfileThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateProfileThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfileThunk.fulfilled, (state, action) => {
        state.loading = false;
        Object.assign(state, action.payload);
      })
      .addCase(updateProfileThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadProfilePictureThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadProfilePictureThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.profilePicURL = action.payload.profilePicURL;
      })
      .addCase(uploadProfilePictureThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = profileSlice.actions;
export default profileSlice.reducer;
